import { Box, FormControl, styled, Typography } from '@mui/material';

interface FormSchoolLogoStyledProps {
  width?: number;
}

export const FormSchoolLogoStyled = styled(FormControl)<FormSchoolLogoStyledProps>(
  ({ theme, width = 170 }) => ({
    width,

    '& .MuiFormHelperText-root': {
      ...theme.typography.body2,

      margin: theme.spacing(0.25, 0, 0),
      padding: theme.spacing(0, 2),
      textAlign: 'center',
    },
  }),
);

export interface FormSchoolLogoPreviewProps {
  preview: string;
}

export const FormSchoolLogoPreview = styled(Box)<FormSchoolLogoPreviewProps>(
  ({ theme, preview }) => ({
    width: '100%',
    height: '100%',
    background: `center / contain no-repeat url(${preview}), ${theme.palette.background.paper}`,
  }),
);

export const FormSchoolLogoParam = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(),
}));

FormSchoolLogoParam.defaultProps = {
  color: 'inherit',
  variant: 'body2',
};
